<template>
  <div class="app-container">
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      label-position="left"
      label-width="150px"
      style="width: 80%; margin-left:50px;"
    >
      <el-form-item label="奖品名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入" />
      </el-form-item>
      <el-form-item label="奖品类型" prop="type">
        <el-select
          v-model="form.type"
          placeholder="请选择"
          style="width: 100%"
          class="filter-item"
          clearable
        >
          <el-option
            v-for="item in prizesOption"
            :key="item.value"
            :label="item.key"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="奖品图标" prop="iconUrl">
        <UploadList
          :typeProps="UPLOAD_IMG_TYPE.BRAND"
          @valueFunc="getImgsValueFunc"
          paramsType="iconUrl"
          :model="form.iconUrl"
          :maxCount="1"
        />
      </el-form-item>
      <el-form-item label="奖品配置" v-if="['quicken','balance','redpacket'].includes(form.type)">
        <div>
          <!--设置奖品-->
          <div>
            <div
                v-for="(item, index) in form.content"
                :key="index"
                class="prizeJson_warp"
            >
              <el-input
                  v-model="item.min"
                  placeholder="最小值"
                  max="100"
                  min="0"
                  style="width: 20%"
                  type="Number"
              >
                <template slot="append">%</template>
              </el-input>
              <el-input
                v-model="item.max"
                placeholder="最大值"
                max="100"
                min="0"
                style="width: 20%"
                type="Number"
              >
                <template slot="append">%</template>
              </el-input>
              <el-input
                  v-model="item.rate"
                  placeholder="抽中概率"
                  max="100"
                  min="0"
                  style="width: 20%"
                  type="Number"
              >
                <template slot="append">%</template>
              </el-input>
              <el-button
                  @click="deletePrizes(index)"
                  size="mini"
                  type="danger"
                  round
              >删除</el-button
              >
            </div>
          </div>
          <div slot="tip" class="el-upload__tip">
            <div>加速包：最小值、最大值为加速百分比范围</div>
            <div>积分 / 现金余额：最小值、最大值为贡献值 x 奖励的百分比范围</div>
          </div>
          <el-button @click="addPrizes" style="width: 100%;" size="small"
          >添加配置</el-button
          >
        </div>
      </el-form-item>
      <el-form-item label="奖品配置" v-if="!['goods','notwin','quicken','balance','redpacket'].includes(form.type)">
        <div>
          <!--设置奖品-->
          <div>
            <div
                v-for="(item, index) in form.content"
                :key="index"
                class="prizeJson_warp"
            >
              <el-input
                  v-model="item.min"
                  placeholder="最小值"
                  style="width: 20%"
                  type="Number"
              />
              <el-input
                v-model="item.max"
                placeholder="最大值"
                style="width: 20%"
                type="Number"
              />
              <el-input
                  v-model="item.rate"
                  placeholder="抽中概率"
                  max="100"
                  min="0"
                  style="width: 20%"
                  type="Number"
              >
                <template slot="append">%</template>
              </el-input>
              <el-button
                  @click="deletePrizes(index)"
                  size="mini"
                  type="danger"
                  round
              >删除</el-button
              >
            </div>
          </div>
          <el-button @click="addPrizes" style="width: 100%;" size="small"
          >添加配置</el-button
          >
        </div>
      </el-form-item>
<!--      <el-form-item label="奖品面值" prop="parValue">-->
<!--        <el-input-->
<!--          v-model="form.parValue"-->
<!--          placeholder="奖品面值"-->
<!--          style="width: 100%"-->
<!--          class="filter-item"-->
<!--          clearable-->
<!--        />-->
<!--      </el-form-item>-->
      <!--      <el-form-item label="实物商品" prop="refId">-->
      <!--        <div>-->
      <!--          <el-input-->
      <!--            v-model="productForm.keyword"-->
      <!--            placeholder="商品名称"-->
      <!--            style="width: 30%"-->
      <!--            clearable-->
      <!--            size="small"-->
      <!--          />-->
      <!--          <el-select-->
      <!--            v-model="productForm.type"-->
      <!--            placeholder="抽奖模式"-->
      <!--            style="width: 120px;margin: 0 10px"-->
      <!--            class="filter-item"-->
      <!--            clearable-->
      <!--            size="small"-->
      <!--          >-->
      <!--            <el-option-->
      <!--              v-for="item in PRODUCT_TYPE"-->
      <!--              :key="item.key"-->
      <!--              :label="item.value"-->
      <!--              :value="item.key"-->
      <!--            />-->
      <!--          </el-select>-->
      <!--          <el-button-->
      <!--            class="filter-item"-->
      <!--            type="primary"-->
      <!--            icon="el-icon-search"-->
      <!--            @click="handleFilter"-->
      <!--            size="small"-->
      <!--            >搜索</el-button-->
      <!--          >-->
      <!--          <el-table-->
      <!--            ref="multipleTable"-->
      <!--            :data="productTableData"-->
      <!--            tooltip-effect="dark"-->
      <!--            style="width: 100%"-->
      <!--            @selection-change="handleSelectionChange"-->
      <!--            size="mini"-->
      <!--            v-loading="tableLoading"-->
      <!--          >-->
      <!--            <el-table-column type="selection" width="55"> </el-table-column>-->
      <!--            <el-table-column prop="id" label="商品编号" width="80">-->
      <!--            </el-table-column>-->
      <!--            <el-table-column prop="mainGraph" label="商品图" width="100">-->
      <!--              <template slot-scope="scope">-->
      <!--                <el-image-->
      <!--                  style="width: 50px; height: 50px"-->
      <!--                  :src="scope.row.mainGraph"-->
      <!--                  fit="cover"-->
      <!--                ></el-image>-->
      <!--              </template>-->
      <!--            </el-table-column>-->
      <!--            <el-table-column prop="name" label="商品名称"> </el-table-column>-->
      <!--          </el-table>-->
      <!--          <div class="pagination-container">-->
      <!--            <el-pagination-->
      <!--              small-->
      <!--              :current-page="productForm.page"-->
      <!--              :page-sizes="[10, 20, 30, 50, 100]"-->
      <!--              :page-size="productForm.limit"-->
      <!--              :total="productTableTotal"-->
      <!--              background-->
      <!--              layout="total, sizes, prev, pager, next, jumper"-->
      <!--              @size-change="handleSizeChange"-->
      <!--              @current-change="handleCurrentChange"-->
      <!--            />-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </el-form-item>-->
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="jumpList">取消</el-button>
      <el-button type="primary" @click="saveAddOrEditData" :loading="btnLoading"
        >确定</el-button
      >
    </div>
  </div>
</template>

<script>
import { getFileName } from "@/utils/utils";
import {
  // RAFFLE_PRIZES_TYPS,
  UPLOAD_IMG_TYPE,
  PRODUCT_TYPE
} from "@/utils/enumUtile";
import { editRafflePrizes, getRafflePrizesDetail,getTypes } from "@/api/raffle";
// import { getGoodsList } from "@/api/product.js";
import UploadList from "@/views/components/uploadList";

export default {
  name: "addOrEditPrizes",
  computed: {
    UPLOAD_IMG_TYPE() {
      return UPLOAD_IMG_TYPE;
    },
    // RAFFLE_PRIZES_TYPS() {
    //   return RAFFLE_PRIZES_TYPS;
    // },
    PRODUCT_TYPE() {
      return PRODUCT_TYPE;
    }
  },
  components: { UploadList },
  data() {
    return {
      rules: {
        type: [
          { required: true, message: "奖品类型不能为空", trigger: "change" }
        ],
        name: [
          { required: true, message: "奖品名称不能为空", trigger: "change" }
        ],
        iconUrl: [
          { required: true, message: "奖品图标不能为空", trigger: "change" }
        ]
        // parValue: [
        //   { required: true, message: "奖品面值不能为空", trigger: "change" }
        // ]
      },
      form: {
        id: 0,
        type: null, //抽奖模式
        name: null, //奖品名称
        iconUrl: null, // 奖品图标
        content:[],//奖品配置
        // parValue: null, // 奖品面值
        // refId: null // 实物商品ID
      },
      btnLoading: false,
      prizesOption:[],// 抽奖奖项
      // productForm: {
      //   status: 2,
      //   keyword: "",
      //   type: "",
      //   page: 1,
      //   pageSize: 10
      // },
      // productTableData: [],
      // productTableTotal: 0, //
      // tableLoading: false
    };
  },
  mounted() {
    this.getTypes();
    const id = this.$route.params.id;
    if (id && id !== 0) {
      this.form.id = id;
      this.getById();
    }

  },
  methods: {
    // handleFilter() {
    //   this.productForm.page = 1;
    //   this.getGoodsList();
    // },
    // handleSizeChange(val) {
    //   this.productForm.limit = val;
    //   this.getGoodsList();
    // },
    // handleCurrentChange(val) {
    //   this.productForm.page = val;
    //   this.getGoodsList();
    // },
    /**
     * 查询要修改的对象
     */
    getById() {
      const params = {
        id: this.form.id
      };
      getRafflePrizesDetail(params).then(resp => {
        if (resp && resp.bizcode === 100) {
          const editObj = resp.data;
          this.form.id = editObj.id;
          this.form.type = editObj.type;
          this.form.name = editObj.name;
          // this.form.parValue = editObj.parValue;
          // this.form.refId = editObj.refId;
          if (editObj.content) {
            this.form.content = this.handContent(JSON.parse(editObj.content),'query', editObj.type);
          }
          if (editObj.iconUrl) {
            const attDataArr = [];
            attDataArr.push({
              url: editObj.iconUrl,
              dbUrl: editObj.iconUrl,
              name: getFileName(editObj.iconUrl)
            });
            this.form.iconUrl = attDataArr;
          }
        }
      });
    },
    /**
     * 查询奖项
     */
    getTypes(){
      getTypes().then(resp=>{
        if(resp && resp.bizcode === 100){
          this.prizesOption = resp.data;
        }
      })
    },
    /**
     * 处理内容
     */
    handContent(data, oper, type) {
      const currentData = data;
      currentData.map(item => {
        var digits = (type === "quicken" || type === "balance" || "redpacket") ? 4 : 2;
        var percent = (type === "quicken" || type === "balance" || "redpacket") ? 100 : 1;
        if (oper === "save") {
          item.rate = (item.rate / percent).toFixed(2);
          item.min = (item.min / percent).toFixed(digits);
          item.max = (item.max / percent).toFixed(digits);
        } else if (oper === "query") {
          item.rate = item.rate * 100;
          item.min = item.min * percent;
          item.max = item.max * percent;
        }
      });
      return currentData;
    },
    /**
     * 确认添加还是编辑
     */
    saveAddOrEditData() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          const form = this.form;
          // if (form.type === 4 && (!form.refId || form.refId === 0)) {
          //   this.$notify({
          //     title: "提示",
          //     message: "请选择需要关联的实物商品",
          //     type: "warning",
          //     duration: 2000
          //   });
          //   return;
          // }
          const params = {
            type: form.type,
            name: form.name,
            // parValue: form.parValue,
            // refId: form.refId
          };
          if (form.content) {
            params.content = JSON.stringify(this.handContent(form.content,'save', this.form.type));
          }
          if (form.iconUrl && form.iconUrl.length !== 0) {
            const urlArr = form.iconUrl.map(obj => obj["dbUrl"]);
            params.iconUrl = urlArr.join(",");
          }
          if (form.id && form.id !== 0) {
            params.id = form.id;
          }
          this.btnLoading = true;
          editRafflePrizes(params)
            .then(() => {
              this.$notify({
                title: "成功",
                message: "保存成功",
                type: "success",
                duration: 2000
              });
              setTimeout(() => {
                this.jumpListFun();
              });
            })
            .finally(() => {
              this.btnLoading = false;
            });
        }
      });
    },
    /**
     *  获取图片的值
     * @param type
     * @param value
     */
    getImgsValueFunc(type, value) {
      if (type === "iconUrl") {
        this.form.iconUrl = value;
      }
    },
    /**
     * 返回到列表
     */
    jumpListFun() {
      this.$router.push({ path: "/raffle/prizes" });
    },
    jumpList() {
      this.$confirm("当前编辑的内容未保存，是否立即返回奖品列表？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.jumpListFun();
      });
    },
    // 添加奖品配置
    addPrizes() {
      let data = this.form.content;
      data.push({
        min: null, // 最小值
        max: null, // 最大值
        rate: null // 中奖概率
      });
      this.form.content = data;
    },
    // 删除奖品
    deletePrizes(index) {
      this.form.content.splice(index, 1);
    },
    /**
     * 查询商品列表
     */
    // getGoodsList() {
    //   this.tableLoading = true;
    //   const params = {
    //     ...this.productForm
    //   };
    //   getGoodsList(params)
    //     .then(resp => {
    //       this.productTableData = resp.data.entitys;
    //       this.productTableTotal = resp.data.totalCount;
    //     })
    //     .finally(() => {
    //       this.tableLoading = false;
    //     });
    // },
    /**
     * 选择关联商品
     * @param item
     */
    // handleSelectionChange(item) {
    //   this.form.refId = item[0].id;
    // }
  }
};
</script>

<style scoped lang="scss">
.dialog-footer {
  text-align: center;
}
.prizeJson_warp {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}
</style>
